import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { CreateManualForm } from "Order/Components/Form/CreateManualForm";
import { BaseCard } from "Shared/Components/Cards/BaseCard";
import { PageContainer } from "Shared/Components/Container";
import type { FC } from "react";

const orderResource = Resources.base.order.shared;

export const OrderCreateManualPage: FC = () => {
	const { t } = useResource();
	return (
		<PageContainer title="Add manual order" description="Create a manual order">
			<BaseCard title={t(orderResource.create)}>
				<CreateManualForm />
			</BaseCard>
		</PageContainer>
	);
};
